const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "y-active"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    d: "M15.03,10c-1.67,0-3.03,1.36-3.03,3.03s1.36,3.03,3.03,3.03,3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03h0ZM30.1,14.71l-4.91,6.43c-.28.37-.44.83-.44,1.3v6.63c0,1.63-1.33,2.95-2.97,2.93-1.61-.02-2.89-1.36-2.89-2.98v-8.56c0-.47.15-.93.44-1.3l5.31-6.95.8-1.05c.98-1.29,2.82-1.53,4.11-.55,1.29.98,1.53,2.82.55,4.11h0Z",
    style: {
      fill: "#2e2b2b",
      fillOpacity: 0.15,
      fillRule: "evenodd",
      stroke: "#2e2b2b"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Fill-31",
    "data-name": "Fill-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    d: "M15.03,10c-1.67,0-3.03,1.36-3.03,3.03s1.36,3.03,3.03,3.03,3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03h0ZM30.1,14.71l-4.91,6.43c-.28.37-.44.83-.44,1.3v6.63c0,1.63-1.33,2.95-2.97,2.93-1.61-.02-2.89-1.36-2.89-2.98v-8.56c0-.47.15-.93.44-1.3l5.31-6.95.8-1.05c.98-1.29,2.82-1.53,4.11-.55,1.29.98,1.53,2.82.55,4.11h0Z",
    style: {
      fill: "#fe5620",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-11",
    "data-name": "path-1",
    d: "M15.03,10c-1.67,0-3.03,1.36-3.03,3.03s1.36,3.03,3.03,3.03,3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03h0ZM30.1,14.71l-4.91,6.43c-.28.37-.44.83-.44,1.3v6.63c0,1.63-1.33,2.95-2.97,2.93-1.61-.02-2.89-1.36-2.89-2.98v-8.56c0-.47.15-.93.44-1.3l5.31-6.95.8-1.05c.98-1.29,2.82-1.53,4.11-.55,1.29.98,1.53,2.82.55,4.11h0Z",
    style: {
      fill: "none",
      stroke: "#2e2b2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.03,10.5c-1.4,0-2.53,1.13-2.53,2.53s1.13,2.53,2.53,2.53,2.53-1.13,2.53-2.53-1.13-2.53-2.53-2.53ZM29.71,14.41h0c.82-1.07.61-2.59-.46-3.41-1.07-.81-2.59-.61-3.41.46l-.8,1.05-5.31,6.95c-.22.29-.34.64-.34,1v8.56c0,1.35,1.07,2.46,2.4,2.48,1.36.02,2.47-1.08,2.47-2.43v-6.63c0-.58.19-1.14.54-1.6l4.91-6.43ZM30.5,15.02h0s0,0,0,0Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeOpacity: 0.5
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.96,9.72c-1.63,0-2.96,1.33-2.96,2.96s1.33,2.96,2.96,2.96,2.96-1.33,2.96-2.96-1.33-2.96-2.96-2.96",
    style: {
      fill: "#f37920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.59,12.52l1.03-1.44s0,0,0,0c.52-.8,1.42-1.33,2.44-1.33,1.6,0,2.91,1.3,2.91,2.91,0,.6-.15,1.16-.49,1.61l-.84,1.11h0s-5.06,6.86-5.06,6.86v-9.71Z",
    style: {
      fill: "#f37920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.74,20.57l.04.03-.04.06v7.06h0v1.64c.06,1.62,1.4,2.92,3.03,2.92,1.53,0,2.8-1.14,3-2.62V12.26l-6.03,8.31Z",
    style: {
      fill: "#f37920"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYActive);
export default __webpack_public_path__ + "static/media/y-active.43a8bc2119b9fd8fd5fac0b07b366ea7.svg";
export { ForwardRef as ReactComponent };